'use client'

import { ActivateTrialDialogs } from './components/activate-trial-dialogs'
import { ActivateTrialLabel } from './components/activate-trial-button-content'
import { ActivateTrialRoot } from './components/activate-trial-root'
import { ActivateTrialToggle } from './components/activate-trial-toggle'
import { ActivateTrialTrigger } from './components/activate-trial-trigger'

export const ActivateTrial = {
  Root: ActivateTrialRoot,
  Trigger: ActivateTrialTrigger,
  Dialogs: ActivateTrialDialogs,
  Label: ActivateTrialLabel,
  Toggle: ActivateTrialToggle,
}
